import React from 'react';
import { BaasicInputTemplate } from 'themes/components';
import PropTypes from 'prop-types';

function BaasicInput(props) {
	return <BaasicInputTemplate {...props} />;
}

BaasicInput.propTypes = {
	onKeyUp: PropTypes.func,
	onBlur: PropTypes.func,
	disabled: PropTypes.bool,
	additionalInfo: PropTypes.string,
	reference: PropTypes.func,
	maxLength: PropTypes.number,
	className: PropTypes.string,
};

BaasicInput.defaultProps = {
	className: '',
	inputClassName: '',
};

export default BaasicInput;



// WEBPACK FOOTER //
// ./src/core/components/forms/BaasicInput.js